import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import RCollapse from "reactstrap/lib/Collapse";
import { gatherClasses, isFunction } from "../../lib/utils";

class Collapse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  toggleOpen = () => {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  };

  render() {
    const {
      trigger,
      body,
      children,
      isOpen,
      onOpened,
      onClosed,
      innerRef,
      dataTestId,
      ...props
    } = this.props;
    const { isOpen: stateIsOpen } = this.state;

    return (
      <div data-testid={dataTestId} className={gatherClasses(props)}>
        {isFunction(trigger) ? trigger(this.toggleOpen, stateIsOpen) : null}
        <RCollapse
          isOpen={isFunction(trigger) ? stateIsOpen : isOpen}
          onEntered={onOpened}
          onExited={onClosed}
          tag="div"
          innerRef={innerRef}
        >
          {isFunction(body) ? body(stateIsOpen) : null}
        </RCollapse>
      </div>
    );
  }
}

Collapse.propTypes = {
  isOpen: PropTypes.bool,
  trigger: PropTypes.func,
  body: PropTypes.func.isRequired,
  onOpened: PropTypes.func,
  onClosed: PropTypes.func,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  innerRef: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.func
  ])
};

Collapse.defaultProps = {
  isOpen: false,
  className: "",
  dataTestId: "orion-collapse"
};

Collapse.displayName = "OrionCollapse";

export default forwardRef((props, ref) => (
  <Collapse innerRef={ref} {...props} />
));
